import Client from '@/repositories/Clients/AxiosClient';
import Config from '@/repositories/Clients/AxiosDefaultConfig';
import { prepareFilterParams } from '@/libs/helper';

const resource = `${Config.basePath}/v1/admin/report`;

export default {
  index(payload) {
    let params = prepareFilterParams(payload);
    params = {
      ...params,
      ...payload,
    };

    return Client.post(resource, params, {
      headers: {
        action: "stock-report",
      },
    });
  },
  exportExcel(payload) {
    let params = prepareFilterParams(payload);
    params = {
      ...params,
      ...payload,
    };


    return Client.post(resource, params, {
      headers: {
        action: "export-excel-stock-report",
      },
      responseType: "blob"
    });
  },
  exportPdf(payload) {
    let params = prepareFilterParams(payload);
    params = {
      ...params,
      ...payload,
    };

    return Client.post(resource, params, {
      headers: {
        action: "export-pdf-stock-report",
      },
      responseType: "blob"
    });
  },
};
